import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import profile from "../../../images/profile.jpg";

const ProfileCover = () => {
  const { t } = useTranslation();

  return (
    <header className="relative bg-bg bg-dot-grid border-b border-border">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 lg:py-24">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-10 lg:gap-14">
          <div className="flex-1 min-w-0">
            <p className="font-mono text-xs uppercase tracking-[0.15em] text-cyan mb-4">
              {t("hero.eyebrow")}
            </p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-text break-words mb-3">
              {t("sidebar.name")}
            </h1>
            <p className="text-lg md:text-xl text-prose leading-relaxed mb-4">
              {t("hero.tagline")}
            </p>
            <p className="font-mono text-xs sm:text-sm text-muted leading-relaxed mb-8">
              {t("hero.locator")}
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="/resume.pdf"
                download
                className="inline-block rounded bg-amber text-bg font-medium px-5 py-2.5 hover:brightness-110 transition"
              >
                {t("sidebar.downloadResume")}
              </a>
              <Link
                to="/works"
                className="inline-block rounded border border-border text-text font-medium px-5 py-2.5 hover:border-cyan hover:text-cyan transition"
              >
                {t("hero.viewWork")}
              </Link>
            </div>
          </div>

          {/* Portrait: square with rounded corners. Sized on the wrapper with an explicit
              w/h pair so the square never depends on the flex row's cross-axis behaviour. */}
          <div className="relative order-first md:order-none shrink-0 w-40 h-40 sm:w-48 sm:h-48 lg:w-60 lg:h-60 xl:w-72 xl:h-72">
            <div
              aria-hidden="true"
              className="hidden md:block pointer-events-none absolute inset-0 translate-x-2 translate-y-2 rounded-2xl border border-cyan/20"
            />
            <img
              src={profile}
              alt={`${t("sidebar.name")}, ${t("hero.tagline")}`}
              width="954"
              height="1154"
              decoding="async"
              className="relative w-full h-full rounded-xl md:rounded-2xl object-cover object-top border border-border"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default ProfileCover;
